import SvgMapPin from '@icons/map-pin.svg?react';
import SvgAir from '@icons/airplane.svg?react';
import SvgGround from '@icons/truck.svg?react';
import SvgTrain from '@icons/train.svg?react';
import SvgBoat from '@icons/ship.svg?react';
import { TransportationTypeEnum } from '@api/ringil-api.v2.tsx';

export enum OfferTypeEnum {
  SPOT = 'SPOT',
  FIXED = 'FIXED',
}

export const getTransportIcon = (type: TransportationTypeEnum, size: number = 4): JSX.Element => {
  const sizeClass = `w-${size} h-${size}`;

  switch (type) {
    case TransportationTypeEnum.GROUND:
      return <SvgGround className={sizeClass} />;
    case TransportationTypeEnum.AIR:
      return <SvgAir className={sizeClass} />;
    case TransportationTypeEnum.TRAIN:
      return <SvgTrain className={sizeClass} />;
    case TransportationTypeEnum.BOAT:
      return <SvgBoat className={sizeClass} />;
    default:
      return <SvgMapPin />;
  }
};

/**
 * getTransportTitle nyní přijímá `tr` funkci místo volání hooku.
 * Použití: getTransportTitle(type, tr)
 */
export const getTransportTitle = (
  type: TransportationTypeEnum,
  tr: (key: string, defaultValue?: string, vars?: Record<string, any>) => string,
): string => {
  return tr(`carrier.demand.quote.transportationType.${type}`, type);
};

export const joinLegInfo = (leg: {
  route?: string;
  fromDate?: string;
  toDate?: string;
  note?: string;
  flightNumber?: string;
  flightType?: string;
  voyageNumber?: string;
  shipType?: string;
  shipCompanyId?: string;
  shipCompanyName?: string;
  trainNumber?: string;
  trainType?: string;
  vehicleType?: string;
}): string => {
  return [
    leg.route,
    leg.fromDate,
    leg.toDate,
    leg.note,
    leg.flightNumber,
    leg.flightType,
    leg.voyageNumber,
    leg.shipType,
    leg.shipCompanyName,
    leg.trainNumber,
    leg.trainType,
    leg.vehicleType,
  ]
    .filter(v => v !== undefined && v !== null && v !== '')
    .join(' | ');
};